import { CollectionName } from '@/shared/lib/sj-orm/constants';
import { UnknownObject } from '@/shared/types/utility-types';

import { KeyPair } from '../../secure-json/core/crypto-core/types';
import { BaseDto, DtoId } from '../../sj-orm/models/base.dto';

/** @deprecated Used only for DTO*/
export type TMigrationVersion = `${number}.${number}.${number}`;

export type CurrentMigrationCollectionItem = Record<string, unknown>;
export type CurrentMigrationCollection<TCollectionItem = CurrentMigrationCollectionItem> = Map<
  string,
  TCollectionItem
>;
export type CurrentMigrationCollectionsData<TCollection = CurrentMigrationCollection> = Map<
  CollectionName,
  TCollection
>;

export type MigratedMigrationCollectionItem = Record<string, unknown>;
export type MigratedMigrationCollection<TCollectionItem = MigratedMigrationCollectionItem> = Map<
  string,
  TCollectionItem
>;
export type MigratedMigrationCollectionsData<TCollection = MigratedMigrationCollection> = Map<
  CollectionName,
  TCollection
>;

export type UpdateCollectionsUpdatedCollections = Map<
  CollectionName,
  Map<DtoId, BaseDto & UnknownObject>
>;

export type UpdateCollectionsCollectionItem = {
  data: BaseDto & UnknownObject;
  updateFields: string[];
  submitted?: boolean;
};

export type UpdateCollectionsCollection = {
  name: CollectionName;
  items: UpdateCollectionsCollectionItem[];
};

export type OnUserActionRequiredProps = {
  collections: UpdateCollectionsCollection[];
};

export type OnUserActionRequiredReturnType = {
  collections: UpdateCollectionsUpdatedCollections;
};

export type OnUserActionRequiredFn = (
  data: OnUserActionRequiredProps,
) => Promise<OnUserActionRequiredReturnType>;

export type MigrationType = {
  version: number;
  migrate: (
    data: CurrentMigrationCollectionsData,
    props: {
      keyPair: KeyPair;
      hookUpdateCollections: OnUserActionRequiredFn;
    },
  ) => MigratedMigrationCollectionsData | Promise<MigratedMigrationCollectionsData>;
};

export type SingleCollectionMigrationOption<
  TCurrentData extends CurrentMigrationCollectionItem = CurrentMigrationCollectionItem,
  TMigratedData extends MigratedMigrationCollectionItem = MigratedMigrationCollectionItem,
> = {
  migrateItemFunction: (currentData: TCurrentData) => TMigratedData;
  collectionName: CollectionName;
};

export type SingleCollectionMigrationProps<
  TCurrentData extends CurrentMigrationCollectionItem = CurrentMigrationCollectionItem,
  TMigratedData extends MigratedMigrationCollectionItem = CurrentMigrationCollectionItem,
> = {
  migrateItemFunction: (currentData: TCurrentData) => TMigratedData;
  collection: CurrentMigrationCollection<TCurrentData>;
};

//#region Errors
// Migration process error
export class MigratorError {
  constructor(
    public message: string,
    public migrationError?: MigrationError,
  ) {}

  toString() {
    if (this.migrationError) {
      return `${this.migrationError.message} ver: ${this.migrationError.version}`;
    } else {
      return this.message;
    }
  }
}

// Single migration error
export class MigrationError extends Error {
  constructor(
    public message: string,
    public version?: number,
  ) {
    super(message);
  }
}
